<script lang="ts">
    import {onMount} from "svelte";
    import ImageView from "../Image/ImageView.svelte";
    import {ImagePathConfig} from "../../../ImagePathConfig";

    export let message;

    onMount(() => {
    });


</script>

<div class="sorry-message-view">
    <div class="image-area">
        <ImageView src={ImagePathConfig.SorryMessage.icon}/>

    </div>
    <div class="title-message-area animation-fade-in-right">
        <div class="title-area">ごめんなさい！</div>
        <div class="message-area">
            { message }
        </div>
    </div>

</div>
<style lang="scss">
    .sorry-message-view {
        border-style: solid;
        border-width: 1px;
        border-color: #0006;
        background-color: var(--background-color);

        filter: drop-shadow(2px 4px 6px #0002);
        margin-top: 30px;


        padding-top: 30px;
        padding-bottom: 30px;
        padding-left: 60px;
        padding-right: 60px;

        display: inline-flex;
        align-items: flex-start;
        gap: 72px;

        .image-area {
            filter: sepia(1) opacity(0.75);
            width: 100px;
            height: 100px;

            :global(.image-view ) {
                height: 100%;
            }
        }

        .title-message-area {
            opacity: 0.75;

            .title-area {
                font-size: 32px;
            }

            .message-area {
                margin-top: 16px;
                font-size: 16px;
            }

        }

    }
</style>